/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { CellSelection, selectionCell } from "prosemirror-tables";

const COLWIDTH_ATTR = "colwidth";

const removeColumnWidth = () => {

    /** @type {import("@tiptap/core").Command} */
    return function ({ state, dispatch, tr }) {

        if (dispatch) {
            const cellPosition = selectionCell(state);
            const selection = CellSelection.colSelection(cellPosition);

            selection.forEachCell(
                (node, pos) => {
                    // remove the colwidth attribute if it exists
                    if (node.attrs[COLWIDTH_ATTR]) {
                        tr.setNodeMarkup(pos, null, {
                            ...node.attrs,
                            [COLWIDTH_ATTR]: null,
                        });
                    }
                }
            );
        }

        return true;
    };
};

export { removeColumnWidth };
